// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__2Wisy","wide":"Tag_wide__3xBfK","fullWidth":"Tag_fullWidth__2F7JN"};